import React from 'react';
import { Box, Typography } from '@mui/material';
import TitleChips from './TitleChips';

const UserNicknameWithEmoticon = ({
    username,
    usernameComponent,
    mainTitle,
    subTitle,
    emoticonUrl,
    emojiText,
    size = 24,
    sx = {},
    twoLine = false,
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: twoLine ? 'column' : 'row', // ✅ 두 줄 구조
                alignItems: 'center', // ✅ 항상 가운데 정렬

                gap: twoLine ? 0.5 : 1,
                ...sx,
            }}
        >
            {/* 줄 1: 칭호 라인 */}
            <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                <TitleChips main={mainTitle} sub={subTitle} />
            </Box>

            {/* 줄 2: 닉네임 + 이모지/이모티콘 */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {usernameComponent ?? (
                    <Typography fontWeight="bold">{username}</Typography>
                )}
                {emoticonUrl && (
                    <img
                        src={emoticonUrl}
                        alt="이모티콘"
                        width={size}
                        height={size}
                    />
                )}
                {emojiText && <span style={{ fontSize: size }}>{emojiText}</span>}
            </Box>
        </Box>
    );
}

export default UserNicknameWithEmoticon;
